<template>
  <b-modal
    centered
    size="lg"
    :visible="show"
    hide-footer
    hide-header
    no-close-on-backdrop
    no-close-on-esc
  >
    <b-container fluid>
      <b-row>
        <b-col>
          <h4 class="text-info m-2">{{ $t("globals.service_device") }}:</h4>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col sm="2">
          <label class="m-2">{{ $t("globals.license_plate") }}:</label>
        </b-col>
        <b-col>
          <b-form-input
            class="m-2"
            size="sm"
            v-model="service_device.license_plate"
          />
        </b-col>
      </b-row>
      <!-- Search Row -->
      <b-row>
        <b-col>
          <b-input-group size="sm" class="my-1">
            <b-input-group-prepend is-text>
              <v-icon name="hdd" :spin="searching_imei"></v-icon>
            </b-input-group-prepend>
            <b-form-input
              placeholder="IMEI"
              v-model="search_imei"
              @keyup.enter="searchByImei"
              :disabled="searching_imei"
            />
            <b-input-group-append>
              <b-btn
                variant="info"
                :disabled="imeiSearchDisabled"
                @click="searchByImei"
              >
                <v-icon v-if="searching_imei" name="spinner" spin></v-icon>
                <v-icon v-else name="search"></v-icon>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <!-- Result devices table -->
      <b-row>
        <b-col>
          <b-table
            small
            primary-key="id"
            current-page="1"
            per-page="5"
            :items="resultDevices"
            :fields="fields"
          >
            <template v-slot:cell(imei)="row">
              <router-link
                style="color:#17a2b8"
                :to="{name: 'device', params:{ id: row.item.id }}"
              >
                {{ row.item.imei }}
              </router-link>
            </template>
            <template v-slot:cell(id)="row">
              <b-form-checkbox
                v-model="row.item.selected"
                :value="true"
                :unchecked-value="false"
                :disabled="service.service_type === 'replace' ? row.item.status !== 'stock' : false"
              >
                {{ row.item.id }}
              </b-form-checkbox>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col>
          <b-btn
            style="float: right; margin: 0.3em;"
            @click="save"
            variant="success"
            :disabled="saveDisabled"
          >
            {{ $t("globals.save") }}
          </b-btn>
          <b-btn
            style="float: left; margin: 0.3em;"
            @click="cancelModal"
            variant="warning"
          >
            {{ $t("globals.cancel") }}
          </b-btn>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    show: Boolean,
    close: Function,
    service: Object,
    service_device: {
      type: Object,
      default: () => ({
        id: null,
        device_id: null,
        imei: "",
        license_plate: null
      })
    }
  },
  data() {
    return {
      search_imei: "",
      resultDevices: [],
      searching_imei: false,
      fields: [
        {
          key: "id",
          label: "ID - Select"
        },
        {
          key: "imei",
          label: "IMEI"
        },
        {
          key: "status",
          label: this.$t("globals.status")
        },
        {
          key: "product",
          label: this.$t("globals.product")
        },
        {
          key: "batch",
          label: this.$t("globals.batch")
        }
      ]
    };
  },
  methods: {
    ...mapActions("axios_mod", ["simpleMutation", "simpleFetch"]),
    cancelModal() {
      this.resultDevices = [];
      this.search_imei = "";

      this.close();
    },
    save() {
      let selected_device = this.resultDevices.filter(e => e.selected)[0]

      let data = {
        query: `
          mutation ServiceDeviceEdit(
            $service_device: ServiceDeviceInput
          ) {
            res: ServiceDeviceEdit (
              service_device: $service_device
            )
          }
        `,
        variables: {
          service_device: {
            id: parseInt(this.service_device.id),
            device_id: parseInt(selected_device.id),
            license_plate: this.service_device.license_plate
          }
        }
      };

      this.simpleMutation({ data, this_ref: this }).then(() => {
        this.cancelModal();
      });
    },
    searchByImei() {
      if (!this.imeiSearchDisabled) {
        const data = {
          query: `
            query  {
              DeviceLikeImei(
                imei: "${this.search_imei}"
                limit: 5
              ) {
                id
                status
                product
                imei
                batch
                selected: default_false
              }
            }
          `
        };

        this.searching_imei = true;
        this.simpleFetch({data, this_ref: this}).then((res) => {
          if (res) {
            this.resultDevices = res.DeviceLikeImei
          }
        }).finally(()=>{
          this.searching_imei = false;
        });
      }
    },
  },
  computed: {
    saveDisabled() {
      return (
        this.noSelectedDevices !== 1
        || this.service_device.license_plate == null
        || this.service_device.license_plate == ""
      );
    },
    imeiSearchDisabled() {
      return (
        this.search_imei==null
        || this.search_imei == ''
        || this.search_imei.length < 4
        || this.searching_imei
      )
    },
    noSelectedDevices() {
      return (
        this.resultDevices.filter(e => e.selected).length
      )
    },
  },
  watch: {
    service_device(new_val) {
      if (new_val != null && new_val.imei != null && new_val.imei != '') {
        const data = {
          query: `
            query  {
              DeviceLikeImei(
                imei: "${new_val.imei}"
                limit: 5
              ) {
                id
                status
                product
                imei
                batch
                selected: default_false
              }
            }
          `
        };

        this.searching_imei = true;
        this.simpleFetch({data, this_ref: this}).then((res) => {
          if (res) {
            this.resultDevices = res.DeviceLikeImei
            this.resultDevices.forEach(d => {
              if (d.imei == new_val.imei) {
                d.selected = true;
              }
            })
          }
        }).finally(()=>{
          this.searching_imei = false;
        });
      }
    }
  }
};
</script>
